import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en.json";
import vi from "./vi.json";
import km from "./km.json";

// FR-023: Vietnamese, English, Khmer UI. `km`'s <html lang="km"> attribute (set by the
// LanguageChanged listener below) is what activates the Noto Sans Khmer font — see
// src/styles/fonts.css and tailwind.config.js's `khmer` font family.
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      vi: { translation: vi },
      km: { translation: km },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "vi", "km"],
    interpolation: { escapeValue: false },
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
